import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { MessageService } from 'primeng/api';

import { Album } from '../../api/albums/album.model';
import { AlbumManagerService } from '../../api/albums/album-manager.service';
import { ApiService } from '../../api/common/api.service';
import { DeviceManagerService } from '../../core/services/device-manager.service';

@Component({
	selector: 'mycampapp-select-albums-dialog',
	templateUrl: './select-albums-dialog.component.html',
	styleUrls: ['./select-albums-dialog.component.less']
})
export class SelectAlbumsDialogComponent implements OnInit
{
	@Input() selectedAlbums: Album[] = [];
	@Output() albumsSelected = new EventEmitter<Album[] | undefined>();

	albums: Album[] = [];
	busy = false;
	visible = true;

	constructor(public deviceManager: DeviceManagerService,
	            private albumManager: AlbumManagerService,
	            private messageService: MessageService) { }

	ngOnInit()
	{
		this.loadData();
	}

	private loadData(): void
	{
		this.busy = true;
		this.albumManager.getAlbum(0).pipe(finalize(() => this.busy = false)).subscribe({
			next: (album: Album) =>
			{
				this.albums = album.ChildAlbums;
			},
			error: error => this.messageService.add({ severity: 'error', summary: 'Error', detail: ApiService.getMessage(error) })
		});
	}

	onOk(): void
	{
		this.albumsSelected.emit(this.selectedAlbums);
	}

	onHide(): void
	{
		this.albumsSelected.emit(undefined);
	}
}
